import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useDisbarmentList() {
  // Use toast
  const toast = useToast()

  const refDisbarmentListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'id', label: '#', sortable: true },
    { label: 'Verzekernemer', key: 'policyHolderRelation', sortable: true },
    { label: 'Product', key: 'product', sortable: true },
    { label: 'Reden', key: 'disbarmentRequestNote', sortable: true },
    { label: 'Aangemaakt op', key: 'timestamp', sortable: true },
    { key: 'actions' },
  ]
  const perPage = ref(10)
  const totalDisbarments = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(false)
  const showOverlay = ref(true)

  const dataMeta = computed(() => {
    const localItemsCount = refDisbarmentListTable.value ? refDisbarmentListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalDisbarments.value,
    }
  })

  const refetchDisbarmentData = () => {
    refDisbarmentListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery], () => {
    refetchDisbarmentData()
  })

  const fetchDisbarment = (ctx, callback) => {
    showOverlay.value = true
    store
      .dispatch('app-disbarments/fetchDisbarments', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortDesc: isSortDirDesc.value,
        sortBy: sortBy.value,
        status: 93,
      })
      .then(response => {
        const { items, _meta } = response.data

        callback(items)
        showOverlay.value = false
        totalDisbarments.value = _meta.totalCount
      })
      .catch(() => {
        showOverlay.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error bij het ophalen van de royementen',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  return {
    fetchDisbarment,
    tableColumns,
    perPage,
    currentPage,
    totalDisbarments,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refDisbarmentListTable,
    refetchDisbarmentData,
    showOverlay,
  }
}
